/* Herbaris product page, 2026. The descriptions were pasted from Word and
   carry blank paragraphs (&nbsp;) between their parts; CSS cannot tell them
   apart, so they are dropped here to keep the spacing of the boards. */
(() => {
  const tidy = () => {
    document
      .querySelectorAll('.f-product-single_block--collapsible_tab .collapsible__content p, .f-product-single_block--collapsible_tab .collapsible__content h5')
      .forEach((el) => {
        if (!el.textContent.trim() && !el.querySelector('img, video, iframe')) el.remove();
      });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidy);
  else tidy();
})();
